import React, { useRef, useState, useEffect } from "react";
import {
  API_END_POINTS_USER,
  COMMON,
  MESSAGE,
  POSTION,
  ROLES,
  ROUTE_STRING,
} from "../../../utils/constant";
import { showToast } from "@/utils/showtoast";
import Image from "next/image";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useRouter } from "next/router";
import logoimg from "../../../public/assets/images/easycampuslogo.jpg";
import verifiedimg from "../../../public/assets/images/check.svg";
import { BsEyeSlash, BsEye } from "react-icons/bs";
import Button from "@/components/common/buttons";
import {
  userRegistrationApi,
  otpValidationApi,
  sendMobileOtpApi,
  sendEmailOtpApi,
  getActiveCampusDataApi,
  getCommonApi,
  getCommonWithoutAuthApi,
} from "@/components/action/easycampus";
import Link from "next/link";

import {
  validateEmail,
  validatePassword,
  // validateFullName,
  validateStudenttype,
  validateUniversityName,
  validateCampusCode,
  validateCampusName,
  validateCompanyName,
  validateMobile,
  validateMobileOtp,
  validateEmailOtp,
  validateTitle,
  validateFirstName,
  validateLastName,
  validateMiddleName,
} from "@/utils/validation";
import { COLOR_CODE } from "@/utils/colorconstant";
import Loader from "../loader";
import { capitalizeFirstLetter } from "@/utils/common";
import ViewTermCondition from "../popup/viewTermConditions";
import SearchableSelect from "../customselect";

const RegistrationForm = ({ formType }) => {
  const [formData, setFormData] = useState({
    title: "",
    firstName: "",
    middleName: "",
    lastName: "",
    // fullName: "",
    campusName: "",
    isUniversity: false,
    universityName: "",
    campusEmail: "",
    campusMobile: "",
    companyName: "",
    companyEmail: "",
    companyMobile: "",
    studentType: "",
    campusCode: "",
    studentEmail: "",
    studentMobile: "",
    password: "",
  });

  const router = useRouter();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // const [fullName, setfullName] = useState("");
  const [title, setTitle] = useState("");
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [campusName, setCampusName] = useState("");
  const [campusCode, setCampusCode] = useState("");
  const [isUniversity, setIsUniversity] = useState(false);
  const [isUniversityType, setIsUniversityType] = useState("");
  const [universityName, setUniversityName] = useState("");
  const [mobile, setMobile] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [studentType, setStudentType] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [campusId, setCampusId] = useState("");
  const [emailErrorMessage, setEmailErrorMessage] = useState("");
  const [passwordErrorMessage, setPasswordErrorMessage] = useState("");
  const [confirmPasswordErrorMessage, setConfirmPasswordErrorMessage] = useState("");
  // const [fullNameErrorMessage, setfullNameErrorMessage] = useState("");
  const [titleErrorMessage, settitleErrorMessage] = useState("");
  const [firstNameErrorMessage, setfirstNameErrorMessage] = useState("");
  const [lastNameErrorMessage, setlastNameErrorMessage] = useState("");
  const [middleNameErrorMessage, setmiddleNameErrorMessage] = useState("");
  const [campusNameErrorMessage, setCampusNameErrorMessage] = useState("");
  const [campusCodeErrorMessage, setCampuscodeErrorMessage] = useState("");
  const [universityNameErrorMessage, setuniversityNameErrorMessage] = useState("");
  const [mobileErrorMessage, setMobileErrorMessage] = useState("");
  const [companyNameErrorMessage, setCompanyNameErrorMessage] = useState("");
  const [studentTypeErrorMessage, setStudentTypeErrorMessage] = useState("");
  const [isUniversityTypeErrorMessage, setIsUniversityTypeErrorMessage] = useState("")
  const [campusIdErrorMessage, setCampusIderrorMessage] = useState("");
  const emailInputRef = useRef(null);
  const passwordInputRef = useRef(null);
  const confirmPasswordInputRef = useRef(null);
  const [passwordType, setPasswordType] = useState("password");
  // const fullNameInputRef = useRef(null);
  const titleInputRef = useRef(null);
  const firstNameInputRef = useRef(null);
  const lastNameInputRef = useRef(null);
  const middleNameInputRef = useRef(null);
  const campusNameInputRef = useRef(null);
  const campuscodeInputRef = useRef(null);
  const universityNameInputRef = useRef(null);
  const mobileInputRef = useRef(null);
  const companyNameInputRef = useRef(null);
  const studentTypeInputRef = useRef(null);
  const isUniversityTypeInputRef = useRef(null)
  const emailOtpInputRef = useRef(null);
  const mobileOtpInputRef = useRef(null);
  const campusIdInputRef = useRef(null)
  const [showLoader, setShowLoader] = useState(false);
  const [otpInputMobile, setOtpInputMobile] = useState("");
  const [otpInputEmail, setOtpInputEmail] = useState("");
  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [otpTimerEmail, setOtpTimerEmail] = useState(60);
  const [otpTimerMobile, setOtpTimerMobile] = useState(60);
  const [otpVerificationError, setOtpVerificationError] = useState("");
  const [emailOtpError, setEmailOtpError] = useState("");
  const [mobileOtpError, setMobileOtpError] = useState("");
  const [showOtpVerifiedPopup, setShowOtpVerifiedPopup] = useState(false);
  const [termConditionModel, setTermConditionModel] = useState(false);
  const [termsAndConditionErrorMessage, setTermsAndConditionErrorMessage] =
    useState("");
  const [isAcceptTearmAndCondition, setIsAcceptTearmAndCondition] = useState(false);
  const fcmToken = sessionStorage.getItem("fcmToken");
  const [campusData, setCampusData] = useState([])
  const [pageSize] = useState(25);
  const [pageNo] = useState(1)

  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);
  const [selectedData, setSelectedData] = useState("")

  let data = {
    pageNo: pageNo,
    pageSize: pageSize
  }

  useEffect(() => {
    let timerEmail;
    let timerMobile;

    if (showOtpPopup && otpTimerEmail > 0) {
      timerEmail = setTimeout(() => {
        setOtpTimerEmail((prevTimer) => prevTimer - 1);
      }, 1000);
    }

    if (showOtpPopup && otpTimerMobile > 0) {
      timerMobile = setTimeout(() => {
        setOtpTimerMobile((prevTimer) => prevTimer - 1);
      }, 1000);
    }

    return () => {
      clearTimeout(timerEmail);
      clearTimeout(timerMobile);
    };
  }, [
    showOtpPopup,
    otpTimerEmail,
    otpTimerMobile,
    setOtpTimerEmail,
    setOtpTimerMobile,
  ]);

  // const handleInputChange = (e) => {
  //   const { name, value, type, checked } = e.target;
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [name]: type === "checkbox" ? checked : value,
  //   }));
  // };

  let item = {
    title: "Terms and condition",
    details:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
  };

  const handleTermCondition = (item) => {
    if (item) {
      //setTermCondition(item)
      setTermConditionModel(true);
    }
  };


  const handleTearmAndConditionStatus = (e) => {
    if (e.target.checked == true) {
      setIsAcceptTearmAndCondition(true);
      setTermsAndConditionErrorMessage("");
    } else if (e.target.checked == false) {
      setIsAcceptTearmAndCondition(false);
      setTermsAndConditionErrorMessage(MESSAGE.TERMS_CONDITION_AND_REQUIRED);
    }
  }



  const handleOtpMobileChange = (e) => {
    const numericValue = e.target.value.replace(/\D/g, "");
    setOtpInputMobile(numericValue.slice(0, 6));
    setMobileOtpError(validateMobileOtp(numericValue.trim()));
  };

  const handleOtpEmailChange = (e) => {
    const numericValue = e.target.value.replace(/\D/g, "");
    setOtpInputEmail(numericValue.slice(0, 6));
    setEmailOtpError(validateEmailOtp(numericValue.trim()));
  };

  const handleOtpSubmit = async () => {
    try {
      if (!otpInputMobile) {
        setMobileOtpError(MESSAGE.MOBILE_OTP_IS_REQUIRED);
      } else if (otpInputMobile) {
        setMobileOtpError(validateMobileOtp(otpInputMobile.trim()));
      }

      if (!otpInputEmail) {
        setEmailOtpError(MESSAGE.EMAIL_OTP_IS_REQUIRED);
      } else if (otpInputEmail) {
        setEmailOtpError(validateMobileOtp(otpInputEmail.trim()));
      }

      if (otpInputEmail && otpInputMobile) {
        const reqBody = {
          mobile: mobile,
          mobileOtp: otpInputMobile,
          email: email,
          emailOtp: otpInputEmail,
        };
        setShowLoader(true);
        const otpVarifyResponse = await otpValidationApi(reqBody);
        if (otpVarifyResponse.data.hasError == false) {
          setShowLoader(false);
          setShowOtpPopup(false);
          setShowOtpVerifiedPopup(true);
          showToast(
            otpVarifyResponse.data.message,
            POSTION.TOP_RIGHT,
            COLOR_CODE.BLUE_600,
            true
          );
        } else {
          showToast(
            otpVarifyResponse.data.message,
            POSTION.TOP_RIGHT,
            COLOR_CODE.RED_600,
            false
          );
          setShowOtpPopup(true);
        }
      }
      setShowOtpPopup(true);
      setShowLoader(false);
    } catch (error) {
      setShowLoader(false);
      console.error(error);
      showToast(error.message, POSTION.TOP_RIGHT, COLOR_CODE.RED_600, true);
    }
  };

  const handleEmailResendOtp = async () => {
    try {
      setShowLoader(true);
      const sendEmailOtpres = await sendEmailOtpApi({ email });
      if (sendEmailOtpres.data.hasError === false) {
        showToast(
          sendEmailOtpres.data.message,
          POSTION.TOP_RIGHT,
          COLOR_CODE.BLUE_600,
          true
        );
        setOtpTimerEmail(60);
        setShowLoader(false);
      } else {
        showToast(
          sendEmailOtpres.data.message,
          POSTION.TOP_RIGHT,
          COLOR_CODE.RED_600,
          false
        );
        setShowOtpPopup(true);
        setShowLoader(false);
      }
    } catch (error) {
      console.error(error);
      showToast(error.message, POSTION.TOP_RIGHT, COLOR_CODE.RED_600, false);
    }
  };

  const handleMobileResendOtp = async () => {
    try {
      setShowLoader(true);
      const sendMobileOtpres = await sendMobileOtpApi({ mobile });
      if (sendMobileOtpres.data.hasError === false) {
        showToast(
          sendMobileOtpres.data.message,
          POSTION.TOP_RIGHT,
          COLOR_CODE.BLUE_600,
          true
        );
        setOtpTimerMobile(60);
        setShowLoader(false);
      } else {
        showToast(
          sendMobileOtpres.data.message,
          POSTION.TOP_RIGHT,
          COLOR_CODE.RED_600,
          false
        );
        setShowOtpPopup(true);
        setShowLoader(false);
      }
    } catch (error) {
      console.error(error);
      showToast(error.message, POSTION.TOP_RIGHT, COLOR_CODE.RED_600, true);
    }
  };

  const handleRegiterSubmit = async (e) => {
    e.preventDefault();
    settitleErrorMessage("");
    setfirstNameErrorMessage("");
    setlastNameErrorMessage("");
    setmiddleNameErrorMessage("");
    // setfullNameErrorMessage("");
    setCampusNameErrorMessage("");
    setuniversityNameErrorMessage("");
    setEmailErrorMessage("");
    setPasswordErrorMessage("");
    setMobileErrorMessage("");
    setCampuscodeErrorMessage("");
    setCampusNameErrorMessage("");
    setCompanyNameErrorMessage("");
    setStudentTypeErrorMessage("");
    setConfirmPasswordErrorMessage("")
    setCampusIderrorMessage("");
    setIsUniversityTypeErrorMessage("");
    setuniversityNameErrorMessage("")

    let forDataToSubmit;
    if (formType === "campus") {
      forDataToSubmit = {
        title: title,
        firstName: firstName,
        lastName: lastName,
        middleName: middleName,
        // fullName: fullName,
        name: campusName,
        isUniversity: isUniversity,
        universityName,
        email,
        mobile,
        password,
        confirmPassword,
        userType: formType,
        fcmToken,
      };

      if (!title) {
        settitleErrorMessage(MESSAGE.TITLE_IS_REQUIRED);
      } else if (title) {
        settitleErrorMessage(validateTitle(title.trim()));
      }

      if (!firstName) {
        setfirstNameErrorMessage(MESSAGE.FIRST_NAME_IS_REQURED);
      } else if (firstName) {
        setfirstNameErrorMessage(validateFirstName(firstName.trim()));
      }

      if (middleName) {
        setmiddleNameErrorMessage(validateMiddleName(middleName.trim()));
      }

      if (lastName) {
        setlastNameErrorMessage(validateLastName(lastName.trim()));
      }

      // if (!fullName) {
      //   setfullNameErrorMessage(MESSAGE.FULL_NAME_IS_REQUIRED);
      // } else if (fullName) {
      //   setfullNameErrorMessage(validateFullName(fullName.trim()));
      // }
      if (!campusName) {
        setCampusNameErrorMessage(MESSAGE.CAMPUS_REQUIRED);
      } else if (campusName) {
        setCampusNameErrorMessage(validateCampusName(campusName.trim()));
      }
      if (!universityName) {
        setuniversityNameErrorMessage(MESSAGE.UNIVERSITY_REQUIRED);
      } else if (universityName) {
        setuniversityNameErrorMessage(
          validateUniversityName(universityName.trim())
        );
      }
      if (!email) {
        setEmailErrorMessage(MESSAGE.EMAIL_IS_REQUIRED);
      } else if (email) {
        setEmailErrorMessage(validateEmail(email.trim()));
      }
      if (!mobile) {
        setMobileErrorMessage(MESSAGE.MOBILE_IS_REQUIRED);
      } else if (mobile) {
        setMobileErrorMessage(validateMobile(mobile.trim()));
      }
      if (!password) {
        setPasswordErrorMessage(MESSAGE.PASSWORD_IS_REQUIRED);
      } else if (password) {
        setPasswordErrorMessage(validatePassword(password.trim()));
      }
      if (!confirmPassword) {
        setConfirmPasswordErrorMessage(MESSAGE.CONFIRM_PASSWORD);
      } else if (confirmPassword) {
        if (confirmPassword !== password)
          setConfirmPasswordErrorMessage(MESSAGE.CONFIRM_PASSWORD_MISS_MATCH);
      }

      if (isAcceptTearmAndCondition === false) {
        setTermsAndConditionErrorMessage(MESSAGE.TERMS_CONDITION_AND_REQUIRED);
      } else {
        setTermsAndConditionErrorMessage("");
      }


      if (!title) {
        titleInputRef.current.focus();
        return;
      } else if (title) {
        if (validateTitle(title.trim())) {
          titleInputRef.current.focus();
          return;
        }
      }

      if (!firstName) {
        firstNameInputRef.current.focus();
        return;
      } else if (firstName) {
        if (validateFirstName(firstName.trim())) {
          firstNameInputRef.current.focus();
          return;
        }
      }

      if (middleName) {
        if (validateLastName(middleName.trim())) {
          middleNameInputRef.current.focus();
          return;
        }
      }

      if (lastName) {
        if (validateLastName(lastName.trim())) {
          lastNameInputRef.current.focus();
          return;
        }
      }
      // if (!fullName) {
      //   fullNameInputRef.current.focus();
      //   return;
      // } else if (fullName) {
      //   if (validateFullName(fullName.trim())) {
      //     fullNameInputRef.current.focus();
      //     return;
      //   }
      // }
      if (!campusName) {
        campusNameInputRef.current.focus();
        return;
      } else if (campusName) {
        if (validateCampusName(campusName.trim())) {
          campusNameInputRef.current.focus();
          return;
        }
      }

      // if (!universityName && isUniversity) {
      //   universityNameInputRef.current.focus();
      //   return;
      // } else if (universityName) {
      //   if (validateUniversityName(universityName.trim())) {
      //     universityNameInputRef.current.focus();
      //     return;
      //   }
      // }
      if (!email) {
        emailInputRef.current.focus();
        return;
      } else if (email) {
        if (validateEmail(email.trim())) {
          emailInputRef.current.focus();
          return;
        }
      }

      if (!mobile) {
        mobileInputRef.current.focus();
        return;
      } else if (mobile) {
        if (validateMobile(mobile.trim())) {
          mobileInputRef.current.focus();
        }
      }

      if (!password) {
        passwordInputRef.current.focus();
        return;
      } else if (password) {
        if (validatePassword(password.trim())) {
          passwordInputRef.current.focus();
          return;
        }
      }
      if (!confirmPassword) {
        confirmPasswordInputRef.current.focus();
        return;
      } else if (confirmPassword) {
        if (confirmPassword !== password) {
          confirmPasswordInputRef.current.focus();
          return;
        }
      }
      if (!isAcceptTearmAndCondition) {
        return;

      }

    } else if (formType === "corporate") {
      forDataToSubmit = {
        title: title,
        firstName: firstName,
        lastName: lastName,
        middleName: middleName,
        // fullName: fullName,
        name: companyName,
        email,
        mobile,
        password,
        confirmPassword,
        userType: formType,
        fcmToken
      };
      // if (!fullName) {
      //   setfullNameErrorMessage(MESSAGE.FULL_NAME_IS_REQUIRED);
      // } else if (fullName) {
      //   setfullNameErrorMessage(validateFullName(fullName.trim()));
      // }

      if (!title) {
        settitleErrorMessage(MESSAGE.TITLE_IS_REQUIRED);
      } else if (title) {
        settitleErrorMessage(validateTitle(title.trim()));
      }

      if (!firstName) {
        setfirstNameErrorMessage(MESSAGE.FIRST_NAME_IS_REQURED);
      } else if (firstName) {
        setfirstNameErrorMessage(validateFirstName(firstName.trim()));
      }

      if (middleName) {
        setmiddleNameErrorMessage(validateMiddleName(middleName.trim()));
      }

      if (lastName) {
        setlastNameErrorMessage(validateLastName(lastName.trim()));
      }

      if (!companyName) {
        setCompanyNameErrorMessage(MESSAGE.COMPANY_REQUIRED);
      } else if (companyName) {
        setCompanyNameErrorMessage(validateCompanyName(companyName.trim()));
      }
      if (!email) {
        setEmailErrorMessage(MESSAGE.EMAIL_IS_REQUIRED);
      } else if (email) {
        setEmailErrorMessage(validateEmail(email.trim()));
      }
      if (!mobile) {
        setMobileErrorMessage(MESSAGE.MOBILE_IS_REQUIRED);
      } else if (mobile) {
        setMobileErrorMessage(validateMobile(mobile.trim()));
      }
      if (!password) {
        setPasswordErrorMessage(MESSAGE.PASSWORD_IS_REQUIRED);
      } else if (password) {
        setPasswordErrorMessage(validatePassword(password.trim()));
      }
      if (!confirmPassword) {
        setConfirmPasswordErrorMessage(MESSAGE.CONFIRM_PASSWORD);
      } else if (confirmPassword) {
        if (confirmPassword !== password)
          setConfirmPasswordErrorMessage(MESSAGE.CONFIRM_PASSWORD_MISS_MATCH);
      }
      if (isAcceptTearmAndCondition == false) {
        setTermsAndConditionErrorMessage(MESSAGE.TERMS_CONDITION_AND_REQUIRED);
      } else {
        setTermsAndConditionErrorMessage("");
      }
      // if (!fullName) {
      //   fullNameInputRef.current.focus();
      //   return;
      // } else if (fullName) {
      //   if (validateFullName(fullName.trim())) {
      //     fullNameInputRef.current.focus();
      //     return;
      //   }
      // }

      if (!title) {
        titleInputRef.current.focus();
        return;
      } else if (title) {
        if (validateTitle(title.trim())) {
          titleInputRef.current.focus();
          return;
        }
      }

      if (!firstName) {
        firstNameInputRef.current.focus();
        return;
      } else if (firstName) {
        if (validateFirstName(firstName.trim())) {
          firstNameInputRef.current.focus();
          return;
        }
      }

      if (middleName) {
        if (validateLastName(middleName.trim())) {
          middleNameInputRef.current.focus();
          return;
        }
      }

      if (lastName) {
        if (validateLastName(lastName.trim())) {
          lastNameInputRef.current.focus();
          return;
        }
      }

      if (!companyName) {
        companyNameInputRef.current.focus();
        return;
      } else if (companyName) {
        if (validateCompanyName(companyName.trim())) {
          companyNameInputRef.current.focus();
          return;
        }
      }
      if (!email) {
        emailInputRef.current.focus();
        return;
      } else if (email) {
        if (validateEmail(email.trim())) {
          emailInputRef.current.focus();
          return;
        }
      }

      if (!mobile) {
        mobileInputRef.current.focus();
        return;
      } else if (mobile) {
        if (validateMobile(mobile.trim())) {
          mobileInputRef.current.focus();
        }
      }

      if (!password) {
        passwordInputRef.current.focus();
        return;
      } else if (password) {
        if (validatePassword(password.trim())) {
          passwordInputRef.current.focus();
          return;
        }
      }
      if (!confirmPassword) {
        confirmPasswordInputRef.current.focus();
        return;
      } else if (confirmPassword) {
        if (confirmPassword !== password) {
          confirmPasswordInputRef.current.focus();
          return;
        }
      }
      if (!isAcceptTearmAndCondition) {
        return;

      }

    } else if (formType === "student") {
      forDataToSubmit = {
        title: title,
        firstName: firstName,
        lastName: lastName,
        middleName: middleName,
        // fullName: fullName,
        studentType,
        campusId: studentType === "oncampusstudent" ? campusCode : campusId,
        isUniversity: isUniversityType === "yes" ? true : false,
        email,
        mobile,
        password,
        confirmPassword,
        userType: studentType,
        fcmToken,
        name: campusId === "others" ? campusName : "",
        universityName: universityName,
      };

      if (!title) {
        settitleErrorMessage(MESSAGE.TITLE_IS_REQUIRED);
      } else if (title) {
        settitleErrorMessage(validateTitle(title.trim()));
      }

      if (!firstName) {
        setfirstNameErrorMessage(MESSAGE.FIRST_NAME_IS_REQURED);
      } else if (firstName) {
        setfirstNameErrorMessage(validateFirstName(firstName.trim()));
      }

      if (middleName) {
        setmiddleNameErrorMessage(validateMiddleName(middleName.trim()));
      }

      if (lastName) {
        setlastNameErrorMessage(validateLastName(lastName.trim()));
      }

      if (!studentType) {
        setStudentTypeErrorMessage(MESSAGE.STUDENT_TYPE_REQUIRED);
      } else if (studentType) {
        setStudentTypeErrorMessage(validateStudenttype(studentType.trim()));
      }
      if (!campusId) {
        setCampusIderrorMessage(MESSAGE.CAMPUS_CODE_REQUIRED);
      }

      if (!campusName) {
        setCampusNameErrorMessage(MESSAGE.CAMPUS_REQUIRED);
      } else if (campusName) {
        setCampusNameErrorMessage(validateCampusName(campusName.trim()));
      }
      if (!isUniversityType) {
        setIsUniversityTypeErrorMessage(MESSAGE.IS_UNIVERSITY);
      }

      if (!universityName) {
        setuniversityNameErrorMessage(MESSAGE.UNIVERSITY_REQUIRED);
      } else if (universityName) {
        setuniversityNameErrorMessage(validateUniversityName(universityName.trim()));
      }

      if (!email) {
        setEmailErrorMessage(MESSAGE.EMAIL_IS_REQUIRED);
      } else if (email) {
        setEmailErrorMessage(validateEmail(email.trim()));
      }
      if (!mobile) {
        setMobileErrorMessage(MESSAGE.MOBILE_IS_REQUIRED);
      } else if (mobile) {
        setMobileErrorMessage(validateMobile(mobile.trim()));
      }
      if (!password) {
        setPasswordErrorMessage(MESSAGE.PASSWORD_IS_REQUIRED);
      } else if (password) {
        setPasswordErrorMessage(validatePassword(password.trim()));
      }
      if (!confirmPassword) {
        setConfirmPasswordErrorMessage(MESSAGE.CONFIRM_PASSWORD);
      } else if (confirmPassword) {
        if (confirmPassword !== password)
          setConfirmPasswordErrorMessage(MESSAGE.CONFIRM_PASSWORD_MISS_MATCH);
      }
      if (isAcceptTearmAndCondition == false) {
        setTermsAndConditionErrorMessage(MESSAGE.TERMS_CONDITION_AND_REQUIRED);
      } else {
        setTermsAndConditionErrorMessage("");
      }
      // if (!fullName) {
      //   fullNameInputRef.current.focus();
      //   return;
      // } else if (fullName) {
      //   if (validateFullName(fullName.trim())) {
      //     fullNameInputRef.current.focus();
      //     return;
      //   }
      // }
      if (!title) {
        titleInputRef.current.focus();
        return;
      } else if (title) {
        if (validateTitle(title.trim())) {
          titleInputRef.current.focus();
          return;
        }
      }

      if (!firstName) {
        firstNameInputRef.current.focus();
        return;
      } else if (firstName) {
        if (validateFirstName(firstName.trim())) {
          firstNameInputRef.current.focus();
          return;
        }
      }

      if (lastName) {
        if (validateLastName(lastName.trim())) {
          lastNameInputRef.current.focus();
          return;
        }
      }

      if (middleName) {
        if (validateLastName(middleName.trim())) {
          middleNameInputRef.current.focus();
          return;
        }
      }

      if (!studentType) {
        studentTypeInputRef.current.focus();
        return;
      } else if (studentType) {
        if (validateStudenttype(studentType.trim())) {
          studentTypeInputRef.current.focus();
          return;
        }
      }

      if (studentType === "oncampusstudent") {

        if (!campusCode) {
          campuscodeInputRef.current.focus();
          return;
        } else if (campusCode) {
          if (validateCampusCode(campusCode.trim())) {
            campuscodeInputRef.current.focus();
            return;
          }
        }

      } else {

        if (!campusId) {
          if (campusIdInputRef.current) {
            campusIdInputRef.current.focus();
          }
          return;

        }

        if (campusId === "others") {
          if (!campusName) {
            campusNameInputRef.current.focus();
            return;
          } else if (campusName) {
            if (validateCampusName(campusName.trim())) {
              campusNameInputRef.current.focus();
              return;
            }
          }

          if (!isUniversityType) {
            isUniversityTypeInputRef.current.focus();
            return;
          }

        }

      }

      if (isUniversityType === "no") {
        if (!universityName) {
          universityNameInputRef.current.focus();
          return;
        } else if (universityName) {
          if (validateUniversityName(universityName.trim())) {
            universityNameInputRef.current.focus();
            return;
          }
        }
      }

      if (!email) {
        emailInputRef.current.focus();
        return;
      } else if (email) {
        if (validateEmail(email.trim())) {
          emailInputRef.current.focus();
          return;
        }
      }

      if (!mobile) {
        mobileInputRef.current.focus();
        return;
      } else if (mobile) {
        if (validateMobile(mobile.trim())) {
          mobileInputRef.current.focus();
        }
      }

      if (!password) {
        passwordInputRef.current.focus();
        return;
      } else if (password) {
        if (validatePassword(password.trim())) {
          passwordInputRef.current.focus();
          return;
        }
      }
      if (!confirmPassword) {
        confirmPasswordInputRef.current.focus();
        return;
      } else if (confirmPassword) {
        if (confirmPassword !== password) {
          confirmPasswordInputRef.current.focus();
          return;
        }
      }
      if (!isAcceptTearmAndCondition) {
        return;

      }
    }
    try {
      setShowLoader(true);
      console.log("amit", forDataToSubmit);
      const registerData = await userRegistrationApi(forDataToSubmit);
      if (registerData.data.hasError === false) {
        showToast(
          registerData.data.message,
          POSTION.TOP_RIGHT,
          COLOR_CODE.BLUE_600,
          true
        );
        setShowOtpPopup(true);
        setShowLoader(false);
      } else {
        showToast(
          registerData.data.message,
          POSTION.TOP_RIGHT,
          COLOR_CODE.RED_600,
          false
        );
      }
      setShowLoader(false);
    } catch (error) {
      setShowLoader(false);
      console.error(error);
      showToast(error.message, POSTION.TOP_RIGHT, COLOR_CODE.BLUE_600, true);
    }
  };

  const handleTitleChange = (e) => {
    if (e.target.value.trim() === "") {
      settitleErrorMessage(MESSAGE.TITLE_IS_REQUIRED);
      titleInputRef.current.focus();
    } else {
      settitleErrorMessage(validateTitle(e.target.value.trim()));
      titleInputRef.current.focus();
    }
    setTitle(e.target.value);
  };

  const handleFirstNameChange = (e) => {
    if (e.target.value.trim() === "") {
      setfirstNameErrorMessage(MESSAGE.FIRST_NAME_IS_REQURED);
      firstNameInputRef.current.focus();
    } else {
      setfirstNameErrorMessage(validateFirstName(e.target.value.trim()));
      firstNameInputRef.current.focus();
    }
    setFirstName(e.target.value);
  };

  const handleMiddleNameChange = (e) => {
    if (e.target.value.trim() === "") {
    } else {
      setmiddleNameErrorMessage(validateMiddleName(e.target.value.trim()));
      middleNameInputRef.current.focus();
    }
    setMiddleName(e.target.value);
  };

  const handleLastNameChange = (e) => {
    if (e.target.value.trim() === "") {
    } else {
      setlastNameErrorMessage(validateLastName(e.target.value.trim()));
      lastNameInputRef.current.focus();
    }
    setLastName(e.target.value);
  };

  const handleEmailChange = (e) => {
    if (e.target.value.trim() === "") {
      setEmailErrorMessage(MESSAGE.EMAIL_IS_REQUIRED);
      emailInputRef.current.focus();
    } else {
      setEmailErrorMessage(validateEmail(e.target.value.trim()));
      emailInputRef.current.focus();
    }
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    if (e.target.value.trim() === "") {
      setPasswordErrorMessage(MESSAGE.PASSWORD_IS_REQUIRED);
      passwordInputRef.current.focus();
    } else {
      setPasswordErrorMessage(validatePassword(e.target.value.trim()));
      passwordInputRef.current.focus();
    }
    setPassword(e.target.value);
  };

  const handleConfirmPasswordChange = (e) => {
    if (e.target.value.trim() === "") {
      setConfirmPasswordErrorMessage(MESSAGE.CONFIRM_PASSWORD);
      confirmPasswordInputRef.current.focus();
    } else if (password === e.target.value) {
      setConfirmPasswordErrorMessage("");

    } else {
      setConfirmPasswordErrorMessage(MESSAGE.CONFIRM_PASSWORD_MISS_MATCH)
      confirmPasswordInputRef.current.focus();
    }
    setConfirmPassword(e.target.value);
  };

  // const handleFullNameChange = (e) => {
  //   if (e.target.value.trim() === "") {
  //     setfullNameErrorMessage(MESSAGE.FULL_NAME_IS_REQUIRED);
  //     fullNameInputRef.current.focus();
  //   } else {
  //     setfullNameErrorMessage(validateFullName(e.target.value.trim()));
  //     fullNameInputRef.current.focus();
  //   }
  //   setfullName(e.target.value);
  // };

  const handleCampusNameChange = (e) => {
    if (e.target.value.trim() === "") {
      setCampusNameErrorMessage(MESSAGE.CAMPUS_REQUIRED);
      campusNameInputRef.current.focus();
    } else {
      setCampusNameErrorMessage(validateCampusName(e.target.value.trim()));
      campusNameInputRef.current.focus();
    }
    setCampusName(e.target.value);
  };

  const handleCampusCodeChange = (e) => {
    if (e.target.value.trim() === "") {
      setCampuscodeErrorMessage(MESSAGE.CAMPUS_CODE_REQUIRED);
      campuscodeInputRef.current.focus();
    } else {
      setCampuscodeErrorMessage(validateCampusCode(e.target.value.trim()));
      campuscodeInputRef.current.focus();
    }
    setCampusCode(e.target.value);
  };

  const handleUniversityNameChange = (e) => {
    const trimmedValue = e.target.value.trim();
    if (trimmedValue === "") {
      setuniversityNameErrorMessage(MESSAGE.UNIVERSITY_REQUIRED);
    } else {
      setuniversityNameErrorMessage(validateUniversityName(trimmedValue))
    }
    setUniversityName(e.target.value);
  };

  const handleMobileChange = (e) => {
    if (e.target.value.trim() === "") {
      setMobileErrorMessage(MESSAGE.MOBILE_IS_REQUIRED);
      mobileInputRef.current.focus();
    } else {
      setMobileErrorMessage(validateMobile(e.target.value.trim()));
      mobileInputRef.current.focus();
    }
    setMobile(e.target.value);
  };

  const handleCompanyChange = (e) => {
    if (e.target.value.trim() === "") {
      setCompanyNameErrorMessage(MESSAGE.COMPANY_REQUIRED);
      companyNameInputRef.current.focus();
    } else {
      setCompanyNameErrorMessage(validateCompanyName(e.target.value.trim()));
      companyNameInputRef.current.focus();
    }
    setCompanyName(e.target.value);
  };

  const handleStudentTypeChange = (e) => {
    if (e.target.value.trim() === "") {
      setStudentTypeErrorMessage(MESSAGE.STUDENT_TYPE_REQUIRED);
      studentTypeInputRef.current.focus();
    } else {
      setStudentTypeErrorMessage(validateCompanyName(e.target.value.trim()));
      studentTypeInputRef.current.focus();
    }
    if (e.target.value === "offcampusstudent") {
      getCampusData(data)
    }
    setCampusId("");
    setCampusName("");
    setIsUniversityType("")
    setUniversityName("")
    setStudentType(e.target.value);
  };

  const handleCampusChange = (item) => {
    if (item.name === "") {
      setCampusIderrorMessage(MESSAGE.CAMPUS_NAME_IS_REQURED);
      campusIdInputRef.current.focus();
    } else {
      setCampusIderrorMessage("")
    }
    setCampusId(item.registrationNumber)
  }

  const handleIsUniversityTypehange = (e) => {
    if (e.target.value === "") {
      setIsUniversityTypeErrorMessage(MESSAGE.IS_UNIVERSITY);
      isUniversityTypeInputRef.current.focus();
    } else {
      setIsUniversityTypeErrorMessage("")
    }
    setIsUniversityType(e.target.value)
  }

  const getCampusData = async (data) => {
    console.log("data", data);

    setShowLoader(true);
    try {
      let action = { apiEndPoint: API_END_POINTS_USER.GET_CAMPUS_FOR_STUDENTS, }
      const response = await getCommonWithoutAuthApi(action, data);
      if (response.data && response.data.hasError === false) {
        let forOthers = [{ registrationNumber: "others", name: "others" }]
        setCampusData([...response.data.data, ...forOthers]);

      }
      setShowLoader(false);
    } catch (error) {
      setShowLoader(false);
      console.error(error);
    }
  };
  console.log("campusDtaa", campusData);


  const titleData = [
    {
      title: "Mr.",
    },
    {
      title: "Mrs.",
    },
    {
      title: "Miss.",
    },
  ];

  const passwordShowHide = (e) => {
    if (passwordType == "password") {
      setPasswordType("text");
    } else {
      setPasswordType("password");
    }
  };

  const toggleDropdown = () => {
    setIsOpen(prevState => !prevState);
  };

  const handleSearchChange = (e) => {
    let value = e.target.value;
    setSearchTerm(e.target.value);
    if (value.length >= 3 || value.length === 0) {
      data = {
        ...data,
        search: value
      }
      getCampusData(data);
    }
  };

  const handleOptionClick = (item) => {
    setSelectedData(item?.name);
    setIsOpen(false);
    handleCampusChange(item)
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const filteredData = Array.isArray(campusData)
    ? campusData.filter((data) => {
      return data.name ? data.name.toLowerCase().includes(searchTerm.toLowerCase()) : false;
    })
    : [];

  console.log("camo", campusId);


  return (
    <>
      {showLoader && <Loader />}

      {termConditionModel && (
        <ViewTermCondition
          isOpen={termConditionModel}
          onClose={() => setTermConditionModel(false)}
          action={{ title: item.title, details: item.details }}
        />
      )}

      <form onSubmit={handleRegiterSubmit} className="zoomSize">
        {/* Add other form fields based on the formType */}

        {formType === "campus" && (
          <>
            <div className="mb-1 grid grid-cols-12 gap-4 w-full">
              <div className="grid col-span-4">
                <select
                  ref={titleInputRef}
                  value={title}
                  onChange={handleTitleChange}
                  className="border border-gray-300 w-full text-base px-2 py-1.5 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
                >
                  <option value="" disabled>Select Title *</option>
                  {titleData.map((titleObj, index) => (
                    <option
                      key={index}
                      value={titleObj.title}
                      selected={titleObj.title === title} // Changed from `title` to `titleObj.title`
                    >
                      {capitalizeFirstLetter(titleObj.title)}
                    </option>
                  ))}
                </select>
                <div id="titleErrorMessage" className="text-red-500 text-sm">
                  {titleErrorMessage}
                </div>
              </div>
              <div className="grid col-span-8 w-full"> {/* Changed from `grid-cols-8` to `grid grid-cols-8` */}
                <input
                  ref={firstNameInputRef}
                  type="text"
                  value={firstName}
                  onChange={handleFirstNameChange}
                  placeholder="First Name *"
                  className="border text-base px-2 py-1.5 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
                />
                <div id="firstNameErrorMessage" className="text-red-500 text-sm">
                  {firstNameErrorMessage}
                </div>
              </div>
            </div>

            <div className="mb-1">
              <input
                ref={middleNameInputRef}
                type="text"
                value={middleName}
                onChange={handleMiddleNameChange}
                placeholder="Middle Name"
                className="border w-full text-base px-2 py-1 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
              />
            </div>
            <div id="middleNameErrorMessage" className="text-red-500 text-sm">
              {middleNameErrorMessage}
            </div>
            <div className="mb-1">
              <input
                ref={lastNameInputRef}
                type="text"
                value={lastName}
                onChange={handleLastNameChange}
                placeholder="Last Name"
                className="border w-full text-base px-2 py-1 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
              />
            </div>
            <div id="lastNameErrorMessage" className="text-red-500 text-sm">
              {lastNameErrorMessage}
            </div>

            <input
              ref={campusNameInputRef}
              type="text"
              value={campusName}
              onChange={handleCampusNameChange}

              placeholder="Name [College/University] *"
              className="mt-1  mb-1 border w-full text-base px-2 py-1 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
            />
            <div id="campusnameErrorMessage" className="text-red-500 text-sm">
              {campusNameErrorMessage}
            </div>
            <div className="flex gap-1 mb-1">
              <input
                type="checkbox"
                id="isUniversity"
                name="isUniversity"
                checked={isUniversity}
                onChange={() => setIsUniversity(!isUniversity)}
                className="mt-1"
              />
              <label htmlFor="isUniversity" className="block text-gray-700">
                Is University?
              </label>
            </div>
            <div className="mb-1">
              <input
                ref={emailInputRef}
                type="email"
                value={email}
                onChange={handleEmailChange}
                placeholder="Campus email *"
                className="mt-1 border w-full text-base px-2 py-1 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
              />
              <div id="emailErrorMessage" className="text-red-500 text-sm">
                {emailErrorMessage}
              </div>
            </div>

            <div className="mb-1">

              <input
                ref={mobileInputRef}
                type="tel"
                pattern="[6789][0-9]{9}"
                value={mobile}
                minLength={10}
                maxLength={10}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/\D/g, "");
                }}
                onChange={handleMobileChange}
                placeholder="Campus mobile *"
                className="mt-1 border w-full text-base px-2 py-1 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
              />
              <div id="mobileErrorMessage" className="text-red-500 text-sm">
                {mobileErrorMessage}
              </div>
            </div>

            <div className="mb-2">

              <div className="relative">
                {passwordType === "password" ? (
                  <>
                    <BsEyeSlash
                      className="text-gray-400 cursor-pointer"
                      onClick={passwordShowHide}
                      style={{
                        position: "absolute",
                        bottom: -27,
                        right: 17,
                      }}
                    />
                  </>
                ) : (
                  <>
                    <BsEye
                      className="text-gray-400 cursor-pointer"
                      onClick={passwordShowHide}
                      style={{
                        position: "absolute",
                        bottom: -27,
                        right: 17,
                      }}
                    />
                  </>
                )}
              </div>
              <input
                ref={passwordInputRef}
                type={passwordType}
                value={password}
                onChange={handlePasswordChange}
                placeholder="Password *"
                className="mt-1 border w-full text-base px-2 py-1 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
              />
            </div>
            <div id="passwordErrorMessage" className="text-red-500 text-sm">
              {passwordErrorMessage}
            </div>
            <div className="mb-1">

              <div
                className="relative">
                {passwordType === "password" ? (
                  <>
                    <BsEyeSlash
                      className="text-gray-400 cursor-pointer"
                      onClick={passwordShowHide}
                      style={{
                        position: "absolute",
                        bottom: -27,
                        right: 17,
                      }}
                    />
                  </>
                ) : (
                  <>
                    <BsEye
                      className="text-gray-400 cursor-pointer"
                      onClick={passwordShowHide}
                      style={{
                        position: "absolute",
                        bottom: -27,
                        right: 17,
                      }}
                    />
                  </>
                )}
              </div>
              <input
                ref={confirmPasswordInputRef}
                type={passwordType}
                value={confirmPassword}
                onChange={handleConfirmPasswordChange}
                placeholder="Confirm Password *"
                className="mt-1 border w-full text-base px-2 py-1 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
              />
              <div id="passwordErrorMessage" className="text-red-500 text-sm">
                {confirmPasswordErrorMessage}
              </div>
            </div>
          </>
        )}
        {formType === "corporate" && (
          <>

            <div className="mb-1 grid grid-cols-12 gap-4 w-full">
              <div className="grid col-span-4">
                <select
                  ref={titleInputRef}
                  value={title}
                  onChange={handleTitleChange}
                  className="border border-gray-300 w-full text-base px-2 py-1.5 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
                >
                  <option value="" disabled>Select Title *</option>
                  {titleData.map((titleObj, index) => (
                    <option
                      key={index}
                      value={titleObj.title}
                      selected={titleObj.title === title} // Changed from `title` to `titleObj.title`
                    >
                      {capitalizeFirstLetter(titleObj.title)}
                    </option>
                  ))}
                </select>
                <div id="titleErrorMessage" className="text-red-500 text-sm">
                  {titleErrorMessage}
                </div>
              </div>
              <div className="grid col-span-8 w-full"> {/* Changed from `grid-cols-8` to `grid grid-cols-8` */}
                <input
                  ref={firstNameInputRef}
                  type="text"
                  value={firstName}
                  onChange={handleFirstNameChange}
                  placeholder="First Name *"
                  className="border text-base px-2 py-1.5 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
                />
                <div id="firstNameErrorMessage" className="text-red-500 text-sm">
                  {firstNameErrorMessage}
                </div>
              </div>
            </div>
            <div className="mb-1">
              <input
                ref={middleNameInputRef}
                type="text"
                value={middleName}
                onChange={handleMiddleNameChange}
                placeholder="Middle Name"
                className="border w-full text-base px-2 py-1 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
              />
            </div>
            <div id="middleNameErrorMessage" className="text-red-500 text-sm">
              {middleNameErrorMessage}
            </div>
            <div className="mb-1">
              <input
                ref={lastNameInputRef}
                type="text"
                value={lastName}
                onChange={handleLastNameChange}
                placeholder="Last Name *"
                className="border w-full text-base px-2 py-1 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
              />
            </div>
            <div id="lastNameErrorMessage" className="text-red-500 text-sm">
              {lastNameErrorMessage}
            </div>

            <div className="mb-1">

              <input
                ref={companyNameInputRef}
                type="text"
                value={companyName}
                onChange={handleCompanyChange}
                placeholder="Company name *"
                className="mt-1 border w-full text-base px-2 py-1 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
              />
              <div
                id="companynameErrorMessage"
                className="text-red-500 text-sm"
              >
                {companyNameErrorMessage}
              </div>
            </div>
            <div className="mb-1">

              <input
                ref={emailInputRef}
                type="email"
                value={email}
                onChange={handleEmailChange}
                placeholder="Company email *"
                className="mt-1 border w-full text-base px-2 py-1 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
              />
              <div id="emailErrorMessage" className="text-red-500 text-sm">
                {emailErrorMessage}
              </div>
            </div>

            <div className="mb-1">

              <input
                ref={mobileInputRef}
                type="tel"
                pattern="[6789][0-9]{9}"
                value={mobile}
                minLength={10}
                maxLength={10}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/\D/g, "");
                }}
                onChange={handleMobileChange}
                placeholder="Company mobile *"
                className="mt-1 border w-full text-base px-2 py-1 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
              />
              <div id="mobileErrorMessage" className="text-red-500 text-sm">
                {mobileErrorMessage}
              </div>
            </div>
            <div className="mb-1">

              <div className="relative">
                {passwordType === "password" ? (
                  <>
                    <BsEyeSlash
                      className="text-gray-400 cursor-pointer"
                      onClick={passwordShowHide}
                      style={{
                        position: "absolute",
                        bottom: -27,
                        right: 17,
                      }}
                    />
                  </>
                ) : (
                  <>
                    <BsEye
                      className="text-gray-400 cursor-pointer"
                      onClick={passwordShowHide}
                      style={{
                        position: "absolute",
                        bottom: -27,
                        right: 17,
                      }}
                    />
                  </>
                )}
              </div>
              <input
                ref={passwordInputRef}
                type={passwordType}
                value={password}
                onChange={handlePasswordChange}
                placeholder="Password *"
                className="mt-1 border w-full text-base px-2 py-1 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
              />
              <div id="passwordErrorMessage" className="text-red-500 text-sm">
                {passwordErrorMessage}
              </div>
            </div>
            <div className="mb-1">

              <div
                className="relative">
                {passwordType === "password" ? (
                  <>
                    <BsEyeSlash
                      className="text-gray-400 cursor-pointer"
                      onClick={passwordShowHide}
                      style={{
                        position: "absolute",
                        bottom: -27,
                        right: 17,
                      }}
                    />
                  </>
                ) : (
                  <>
                    <BsEye
                      className="text-gray-400 cursor-pointer"
                      onClick={passwordShowHide}
                      style={{
                        position: "absolute",
                        bottom: -27,
                        right: 17,
                      }}
                    />
                  </>
                )}
              </div>
              <input
                ref={confirmPasswordInputRef}
                type={passwordType}
                value={confirmPassword}
                onChange={handleConfirmPasswordChange}
                placeholder="Confirm Password *"
                className="mt-1 border w-full text-base px-2 py-1 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
              />
              <div id="passwordErrorMessage" className="text-red-500 text-sm">
                {confirmPasswordErrorMessage}
              </div>
            </div>
          </>
        )}
        {formType === "student" && (
          <>

            <div className="mb-1 grid grid-cols-12 gap-4 w-full">
              <div className="grid col-span-4 mb-1">
                <select
                  ref={titleInputRef}
                  value={title}
                  onChange={handleTitleChange}
                  className="border border-gray-300 w-full text-base px-2 py-1.5 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
                >
                  <option value="" disabled>Select Title *</option>
                  {titleData.map((titleObj, index) => (
                    <option
                      key={index}
                      value={titleObj.title}
                      selected={titleObj.title === title} // Changed from `title` to `titleObj.title`
                    >
                      {capitalizeFirstLetter(titleObj.title)}
                    </option>
                  ))}
                </select>
                <div id="titleErrorMessage" className="text-red-500 text-sm">
                  {titleErrorMessage}
                </div>
              </div>
              <div className="grid col-span-8 w-full mb-1"> {/* Changed from `grid-cols-8` to `grid grid-cols-8` */}
                <input
                  ref={firstNameInputRef}
                  type="text"
                  value={firstName}
                  onChange={handleFirstNameChange}
                  placeholder="First Name *"
                  className="border text-base px-2 py-1.5 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
                />
                <div id="firstNameErrorMessage" className="text-red-500 text-sm">
                  {firstNameErrorMessage}
                </div>
              </div>
            </div>
            <div className="mb-1 grid grid-cols-1 lg:grid-cols-2 gap-2 w-full">
              <div className="">
                <input
                  ref={middleNameInputRef}
                  type="text"
                  value={middleName}
                  onChange={handleMiddleNameChange}
                  placeholder="Middle Name"
                  className="border w-full text-base px-2 py-1.5 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
                />

                <div id="middleNameErrorMessage" className="text-red-500 text-sm">
                  {middleNameErrorMessage}
                </div>
              </div>
              <div className="">
                <input
                  ref={lastNameInputRef}
                  type="text"
                  value={lastName}
                  onChange={handleLastNameChange}
                  placeholder="Last Name *"
                  className="border w-full text-base px-2 py-1.5 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
                />

                <div id="lastNameErrorMessage" className="text-red-500 text-sm">
                  {lastNameErrorMessage}
                </div>
              </div>
              <div className="">

                <select
                  ref={studentTypeInputRef}
                  value={studentType}
                  onChange={handleStudentTypeChange}
                  className="mt-1 border border-gray-300 w-full text-base px-2 py-1.5 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
                >
                  <option value="">
                    Select Student Type
                  </option>
                  <option value="oncampusstudent">On Campus</option>
                  <option value="offcampusstudent">
                    Off Campus
                  </option>
                </select>
                <div
                  id="studentTypeErrorMessage"
                  className="text-red-500 text-sm"
                >
                  {studentTypeErrorMessage}
                </div>
              </div>

              {studentType === ROLES.ON_STUDENT && (
                <div className="">
                  <input
                    ref={campuscodeInputRef}
                    type="text"
                    value={campusCode}
                    onChange={handleCampusCodeChange}
                    placeholder="Campus code *"
                    className="mt-1 border w-full text-base px-2 py-1 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
                  />
                  <div id="campusCodeErrorMessage" className="text-red-500 text-sm">
                    {campusCodeErrorMessage}
                  </div>
                </div>
              )}

              {studentType === ROLES.OFF_STUDENT && (
                <>
                  <div className="mt-1">
                    <div className="dropdown-container" ref={dropdownRef}>
                      <div className="dropdown-header-disabled dropdown-header" onClick={toggleDropdown}>
                        {capitalizeFirstLetter(selectedData) || "Select Campus"}
                        <span>
                          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                            <path fill="currentColor" d="M16.293 9.293L12 13.586L7.707 9.293l-1.414 1.414L12 16.414l5.707-5.707z" />
                          </svg>
                        </span>
                      </div>
                      {isOpen && (
                        <div className="dropdown-list">
                          <input
                            type="text"
                            value={searchTerm}
                            onChange={handleSearchChange}
                            placeholder="Search..."
                            className="dropdown-search"
                            // disabled={dropdownData?.disabled}
                            ref={campusIdInputRef}
                          />
                          {showLoader ? (
                            <div>Loading...</div>
                          ) : (
                            <ul>
                              {filteredData.length > 0 ? (
                                filteredData.map((item, index) => (
                                  <li
                                    key={item?._id || index}
                                    className={`dropdown-list-item `}
                                    onClick={() => handleOptionClick(item)}
                                  >
                                    {capitalizeFirstLetter(item?.name)}
                                  </li>
                                ))
                              ) : (
                                <li className="dropdown-list-item">No data found</li>
                              )}
                            </ul>
                          )}
                        </div>
                      )}
                    </div>

                    <div id="campusIdErrorMessage" className="text-red-500 text-sm">
                      {campusIdErrorMessage}
                    </div>
                  </div>

                  {campusId === "others" && (
                    <>
                      <div className="">
                        <input
                          ref={campusNameInputRef}
                          type="text"
                          value={campusName}
                          onChange={handleCampusNameChange}
                          placeholder="Name [College/University] *"
                          className="mt-1 border w-full text-base px-2 py-1.5 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
                        />
                        <div id="emailErrorMessage" className="text-red-500 text-sm">
                          {campusNameErrorMessage}
                        </div>
                      </div>

                      <div className="">
                        <select
                          ref={isUniversityTypeInputRef}
                          value={isUniversityType}
                          onChange={handleIsUniversityTypehange}
                          className="mt-1 border border-gray-300 w-full text-base px-2 py-1.5 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
                        >
                          <option value="">
                            Is University
                          </option>
                          <option value="yes">Yes</option>
                          <option value="no">
                            No
                          </option>
                        </select>
                        <div id="emailErrorMessage" className="text-red-500 text-sm">
                          {isUniversityTypeErrorMessage}
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
              {isUniversityType === "no" && (
                <div className="">
                  <input
                    ref={universityNameInputRef}
                    type="text"
                    value={universityName}
                    onChange={handleUniversityNameChange}
                    placeholder="University Name *"
                    className="mt-1 border w-full text-base px-2 py-1.5 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
                  />
                  <div id="emailErrorMessage" className="text-red-500 text-sm">
                    {universityNameErrorMessage}
                  </div>
                </div>
              )}


              <div className="">

                <input
                  ref={emailInputRef}
                  type="text"
                  value={email}
                  onChange={handleEmailChange}
                  placeholder="Student email *"
                  className="mt-1 border w-full text-base px-2 py-1.5 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
                />
                <div id="emailErrorMessage" className="text-red-500 text-sm">
                  {emailErrorMessage}
                </div>
              </div>
              <div className="">

                <input
                  ref={mobileInputRef}
                  type="tel"
                  pattern="[6789][0-9]{9}"
                  value={mobile}
                  minLength={10}
                  maxLength={10}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, "");
                  }}
                  onChange={handleMobileChange}
                  placeholder="Student mobile *"
                  className="mt-1 border w-full text-base px-2 py-1.5 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
                />
                <div id="mobileErrorMessage" className="text-red-500 text-sm">
                  {mobileErrorMessage}
                </div>
              </div>

              <div className="">

                <div
                  className="relative">
                  {passwordType === "password" ? (
                    <>
                      <BsEyeSlash
                        className="text-gray-400 cursor-pointer"
                        onClick={passwordShowHide}
                        style={{
                          position: "absolute",
                          bottom: -27,
                          right: 17,
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <BsEye
                        className="text-gray-400 cursor-pointer"
                        onClick={passwordShowHide}
                        style={{
                          position: "absolute",
                          bottom: -27,
                          right: 17,
                        }}
                      />
                    </>
                  )}
                </div>
                <input
                  ref={passwordInputRef}
                  type={passwordType}
                  value={password}
                  onChange={handlePasswordChange}
                  placeholder="Password *"
                  className="mt-1 border w-full text-base px-2 py-1.5 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
                />
                <div id="passwordErrorMessage" className="text-red-500 text-sm">
                  {passwordErrorMessage}
                </div>
              </div>
              <div className="mb-1">

                <div
                  className="relative">
                  {passwordType === "password" ? (
                    <>
                      <BsEyeSlash
                        className="text-gray-400 cursor-pointer"
                        onClick={passwordShowHide}
                        style={{
                          position: "absolute",
                          bottom: -27,
                          right: 17,
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <BsEye
                        className="text-gray-400 cursor-pointer"
                        onClick={passwordShowHide}
                        style={{
                          position: "absolute",
                          bottom: -27,
                          right: 17,
                        }}
                      />
                    </>
                  )}
                </div>
                <input
                  ref={confirmPasswordInputRef}
                  type={passwordType}
                  value={confirmPassword}
                  onChange={handleConfirmPasswordChange}
                  placeholder="Confirm Password *"
                  className="mt-1 border w-full text-base px-2 py-1 focus:outline-none focus:ring-0 focus:border-gray-600 rounded-md"
                />
                <div id="passwordErrorMessage" className="text-red-500 text-sm">
                  {confirmPasswordErrorMessage}
                </div>
              </div>
            </div>
          </>
        )}

        <input
          type="checkbox"
          value={isAcceptTearmAndCondition}
          onChange={handleTearmAndConditionStatus}
          className="mt-0 rounded-md "
        /> I agree to
        <Link target="#" href="https://www.easycampus.ai/privacypolicy" 
        //onClick={() => handleTermCondition(item)}
          className="text-[#1e336a] font-semibold"> Terms & conditions</Link> and

        <Link target="#"  href="https://www.easycampus.ai/privacypolicy" 
        //onClick={() => handleTermCondition(item)}
        className="text-[#1e336a] font-semibold"> Privacy Policy.</Link>

        <div
          id="termsAndConditionErrorMessage"
          className="text-red-500 text-sm ml-5"
        >
          {termsAndConditionErrorMessage}
        </div>
        {/* <div className="flex items-center justify-center congratulation font-inter">

          Coming Soon
        </div> */}


        <button
          className="mt-5 w-full text-center px-6 py-2 bg-[#1e336a] text-white rounded-md hover:bg-[#002E6E] focus:outline-none"
          onClick={handleRegiterSubmit}

        >
          <div
            type="submit">Submit</div>
        </button>
        <div className="mt-5 flex gap-2 justify-center">
          <p>Already have an account?</p>
          <Link href="/" className="text-[#00BAF1]">
            Login
          </Link>
        </div>
        {/* <ToastContainer /> */}
      </form>
      {showOtpPopup && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div
              className="fixed inset-0 transition-opacity"
              aria-hidden="true"
            >
              <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>
            {showLoader && <Loader />}
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>

            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
              <div className="bg-white p-5 flex flex-col items-center">
                <div className="items-center w-[40%]">
                  <Image src={logoimg} alt="logoimg" />
                </div>
                <h1 className="flex justify-center text-2xl font-semibold mb-1 text-[#012970]">
                  OTP VERIFICATION
                </h1>
                <div className="w-[40%] text-[10px]">
                  We Will send you a one time Password on your{" "}
                  <strong>Mobile Number & Email</strong>
                </div>
                <div className="mb-2 w-full">
                  <input
                    type="text"
                    placeholder="Enter Mobile OTP"
                    value={otpInputMobile}
                    onChange={handleOtpMobileChange}
                    className="mt-2 border w-100 text-base px-2 py-1 focus:outline-none focus:ring-0 focus:border-[#1e336a] rounded-md w-[100%]"
                  />
                  <div className="text-red-500">
                    {otpVerificationError}
                    {mobileOtpError}
                  </div>

                  <div className="flex items-center justify-between mt-2">
                    <p className="text-gray-500"> {otpTimerMobile} seconds</p>
                    <button
                      disabled={otpTimerMobile > 0}
                      onClick={handleMobileResendOtp}
                      className={`text-[#1e336a] hover:underline focus:outline-none ${otpTimerMobile > 0 ? "cursor-not-allowed" : ""
                        }`}
                    >
                      Resend OTP
                    </button>
                  </div>
                </div>
                <div className="mb-2 w-full">
                  <input
                    type="text"
                    placeholder="Enter Email OTP"
                    value={otpInputEmail}
                    onChange={handleOtpEmailChange}
                    className="'mt-2 border w-full text-base px-2 py-1 focus:outline-none focus:ring-0 focus:border-[#1e336a] rounded-md"
                  />
                  <div className="text-red-500">
                    {otpVerificationError}
                    {emailOtpError}
                  </div>
                  <div className="flex items-center justify-between mt-2">
                    <p className="text-gray-500">{otpTimerEmail} seconds</p>
                    <button
                      onClick={handleEmailResendOtp}
                      disabled={otpTimerEmail > 0}
                      className={`text-[#1e336a] hover:underline focus:outline-none ${otpTimerEmail > 0 ? "cursor-not-allowed" : ""
                        }`}
                    >
                      Resend OTP
                    </button>
                  </div>
                </div>
                <div className="flex items-center justify-between w-full">
                  <button
                    onClick={handleOtpSubmit}
                    className="w-full px-6 py-2 bg-[#1e336a] text-white rounded-md hover:bg-[#1e336a] focus:outline-none"
                  >
                    Submit
                  </button>

                  <button
                    onClick={() => setShowOtpPopup(false)}
                    className="absolute top-2 right-2 text-gray-500 cursor-pointer"
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showOtpVerifiedPopup && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
              <div
                className="fixed inset-0 transition-opacity"
                aria-hidden="true"
              >
                <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
              </div>
              {showLoader && <Loader />}

              <span
                className="hidden sm:inline-block sm:align-middle sm:h-screen"
                aria-hidden="true"
              >
                &#8203;
              </span>

              <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                <div className="bg-white p-5 flex flex-col items-center">
                  <div className="items-center w-[40%]">
                    <Image src={logoimg} alt="logoimg" />
                  </div>

                  <Image src={verifiedimg} alt="verified" className="w-[40%]" />
                  <h1 className="text-xl block text-center font-semibold mt-3 text-[#012970] mb-3">
                  Thank you for registering!
                  </h1>
                  <div className="w-[70%] text-[10px]">
                  We’re pleased to inform you that your account has been successfully registered on easycampus. Please log in to proceed with the next steps.
                  </div>

                  <div className="mt-5 px-6 py-2 bg-[#1e336a] text-white rounded-md hover:bg-[#002E6E] focus:outline-none text-center">
                    <Link href="/" className="text-[#1e336a]">
                      {/* <Button value={{ buttonText: COMMON.BACK_TO_LOGIN, btnActionType: COMMON.SUBMIT }}/> */}
                      {/* <button
                  value={true}
                    className="text-white p-2 bg-[#1e336a]  hover:bg-[#3b5998]/90 focus:ring-4 focus:outline-none focus:ring-[#3b5998]/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 me-2 mb-2"
                
                  >
                    {COMMON.BACK_TO_LOGIN}
                  </button> */}

                      <button className="w-full px-6 py-2 bg-[#1e336a] text-white rounded-md hover:bg-[#002E6E] focus:outline-none">
                        {COMMON.BACK_TO_LOGIN}
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

<ToastContainer />
    </>
  );
};

export default RegistrationForm;